// Dummy Motor Data for the demo EV

const dummyMotorData = {
  temperature: 65.3, // °C
  rpm: 0, // Currently parked
  torque: 0, // Nm (max 260)
  power: 0, // kW (max 100)
  efficiency: 94.2, // %
  status: 'idle', // idle, active, regenerating

  specs: {
    maxPower: 105, // kW
    maxTorque: 260, // Nm
    maxRpm: 10000, // RPM
    type: 'Permanent Magnet Synchronous Motor'
  },

  cooling: {
    status: 'normal',
    fluidTemp: 42.5, // °C
    flowRate: 8.5 // L/min
  },

  faults: [],

  history: {
    maxTemp: 87.5, // °C
    avgEfficiency: 92.8, // %
    totalRotations: 45678900,
    operatingHours: 287 // hours
  },

  performance: {
    acceleration0to60: 9.9, // seconds (estimated)
    peakPowerDelivered: 98.5, // kW
    avgTorqueDelivered: 180 // Nm
  }
};

export default dummyMotorData;
